import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { BaseBus } from "./BaseBus";
export class BidHVACBus extends BaseBus{
    constructor(busObj: BidHVACBus) {
        super(busObj);

    }
    CID(): any {
        return this.hvacFunctionId ;
    }
    setId(id: any) {
        this.hvacFunctionId  = id;
    }
    initialize(data: BidHVACBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setParentId(id: any) {
        this.bidSheetDetailId=id;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: BidHVACBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);

    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        this.updateDt = date;
        if (this.hasId) {
            this.updateUserId = userId;

        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    }
    bidHVACId:string;
    bidSheetDetailId:string;
    hvacFunctionId:string;
    stHours:number;
    otHours:number;
    dtHours:number;
    materialsCost:number;
    insertDt:Date;
    insertUserId:string;
    updateDt:Date;
    updateUserId:string;
    description:string;
    sequence:number;

}